import { Grid, withStyles } from '@material-ui/core'
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd'
import RepeatIcon from '@material-ui/icons/Repeat'
import React, { useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import Button from '../../../../components/Button'
import FormButton from '../../../../components/form/FormButton'
import FormattedMessageWithBold from '../../../../components/FormattedMessageWithBold'
import { DialogContext } from '../../../../components/layout/dialog'
import { ActionPanelContext } from '../../../../components/layout/rightPanels'
import { useSnackbar } from '../../../../components/layout/snackbar/SnackbarContext'
import { colors, PARAMETRES_TACHE, TYPE_DIALOG } from '../../../../utils/constants'
import { LocalDate } from '../../../../utils/date/local-date'
import { LocalDateTime } from '../../../../utils/date/local-date-time'
import { DateFormat } from '../../../../utils/date/model/date'
import { formatTime } from '../../gestionRessource/utils/ressourceUtils'
import CreerTache, { formName } from '../form/CreerTache'
import { useGestionTacheContext } from '../GestionTacheProvider'
import { getRecurrences } from '../gestionTachesApi'
import { createTache } from '../services/api'

const styles = {
	titrePopin: {
		display: 'flex',
		alignItems: 'center',
		gap: 15,
		letterSpacing: 0,
		width: 550,
	},
	titreIcon: {
		color: colors.primary
	},
	contenuPopin: {
		padding: '10px 30px'
	}
}

/**
 * Injecteur pour l'ouverture du panel d'ajout d'une tâche
 */
export const injectCreateTask = (WrappedComponent) => {
	const CreateTaskInjector = ({ classes, ...props }) => {
		const { openPanel, closePanel, toggleClickAway } = useContext(ActionPanelContext)
		const { snackSuccess, snackError } = useSnackbar()
		const { semaineSelection } = useGestionTacheContext()
		const { openDialog, closeDialog } = React.useContext(DialogContext)

		const formattedMessageBase = 'gestionTaches.ecranPlanification.ajout'

		const openPopinRecurrence = (values, onSuccess) => {
			if (values.parametres && values.parametres.includes(PARAMETRES_TACHE.RECURRENTE)) {
				toggleClickAway(false)
				const data = { ...values, jours: values.jours && values.jours.map(j => j.code) }
				getRecurrences(data).then(recurrences => {
					openDialog(
						<span style={styles.titrePopin}>
							<RepeatIcon style={styles.titreIcon}/>
							<FormattedMessage id={`${formattedMessageBase}.popin.recurrence.title`}/>
						</span>,
						<span style={styles.contenuPopin}>
							<FormattedMessage
								id={`${formattedMessageBase}.popin.recurrence.texte`}
								values={{
									culture: values.cultureLabel,
									surfaceSize: (values.surface || []).length,
									surface: values.surfaceLabel,
									surfaces: (values.surface || []).map(surface => surface.label).join(', ')  }}
							/>
							<ul>
								{recurrences.map(r => <li key={r.id}>
									<FormattedMessageWithBold
										id={`${formattedMessageBase}.popin.recurrence.info`}
										values={{type: `${values.typeLabel}`.toLowerCase(), date: LocalDate.fromAPI(r).format(DateFormat.SHORT_DATE)}}
									/>
								</li>)}
							</ul>
						</span>,
						[
							<Button
								variant="text"
								withBorder={false}
								onClick={() => {
									handleCreateTask(data, onSuccess)
									toggleClickAway(true)
									closeDialog()
								}}
							>
								<FormattedMessage id="actions.confirm"/>
							</Button>
						], TYPE_DIALOG.ACTION
					)
				})
			} else {
				const data = { ...values, jours: values.jours && values.jours.map(j => j.code) }
				handleCreateTask(data, onSuccess)
			}
		}

		const handleCreateTask = React.useCallback((values, onSuccess) => {
			const date = values.parametres && values.parametres.includes(PARAMETRES_TACHE.RECURRENTE) ? LocalDate.fromString(semaineSelection) : LocalDate.fromJS(values.date)
			createTache(date.format(DateFormat.SHORT_DATE_WITH_DASH),
				{
					...values,
					surfaces: (values.surface || []).map(option => option.code),
					date: LocalDateTime.toApiDateTime(new Date(values.date)),
					modele: values.modele,
					jours: values.jours,
					debutHeure: values.debutHeure ? formatTime(values.debutHeure) : undefined,
					semaineSelection: LocalDate.fromString(semaineSelection).format(DateFormat.SHORT_DATE_WITH_DASH)
				}).then(() => {
				closePanel()
				snackSuccess({ id: `${formattedMessageBase}.success` })
				if (onSuccess) {
					onSuccess()
				}
			}).catch(() => {
				snackError({ id: `${formattedMessageBase}.error` })
			})
		}, [closePanel, semaineSelection, snackError, snackSuccess])

		const openCreateTask = React.useCallback((onSuccess) => {
			const buttons = [
				<FormButton
					type="primary"
					formName={formName}
				>
					<FormattedMessage id="actions.save"/>
				</FormButton>
			]

			openPanel(
				<Grid container alignItems="center" style={{ gap: 20 }}>
					<PlaylistAddIcon color="primary"/>
					<FormattedMessage id={`${formattedMessageBase}.title`}/>
				</Grid>,
				<CreerTache onSubmit={values => openPopinRecurrence(values, onSuccess)} semaineSelection={semaineSelection}/>,
				buttons
			)
		}, [closePanel, handleCreateTask, openPanel, semaineSelection])

		return <WrappedComponent
			{...props}
			openCreateTask={openCreateTask}
		/>
	}

	return withStyles(styles)(CreateTaskInjector)
}
